import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { AuthService } from '../../../../system/auth.service';
import { ModuleService } from '../../../../api/Services/maintenance/module.service';
import { ToastrService } from 'ngx-toastr';
import { TabService } from '../../../../tabconfig/tab.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from '../../../../common/dialog.service';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
 


@Component({
  selector: 'app-modules-add',
  templateUrl: './modules-add.component.html',
  styleUrls: ['./modules-add.component.css']
})
export class ModulesAddComponent implements OnInit {

  public parameters: any[];
  public moduleList: any[];

  public editActivo = false;
  public displayedColumns: string[] = ['mod_vc_name', 'mod_in_order', 'opcion'];
  public dataSource = new MatTableDataSource<any[]>();

  @Input() cou_in_id;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('paginatorDatasource', { read: MatPaginator, static: true }) paginator: MatPaginator;

  @Output() SendDataModule = new EventEmitter();
  
  ContentCourses: FormGroup;

  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private moduleServices: ModuleService,
    private toastr: ToastrService,
    private tabService: TabService,
    private dialog: MatDialog,
    private dialogService: DialogService,
    
  ) { }

  ngOnInit(): void {
    this.LoadInitial();
    this.initForm();

    if (this.cou_in_id != null) {
      if (this.cou_in_id > 0) {
        console.log("COD CURSO ==>" + this.cou_in_id);
        this.LoadModuleList();
      }
    }
  }

  public initForm() {
    this.ContentCourses = this.formBuilder.group({
      mod_in_id: [null],
      cou_in_id: [null, Validators.required],
      cou_in_category: [null],
      cou_vc_category: [null],
      cou_vc_name: [null],
      mod_in_type_module: [1],
      mod_vc_name: [null, Validators.required],
      mod_vc_name_short: [null],
      mod_tx_description: [null, Validators.required],
      mod_vc_image: [null],
      mod_in_order: [null, Validators.required],
      mod_in_status: [1]
    });

  }

  public LoadInitial() {
    this.parameters = this.authService.getParameters();
  }

  public LoadModuleList() {
    let cou_in_id = this.cou_in_id;
    this.moduleServices.GetAll(cou_in_id).subscribe(
      data => {
        console.log(data)

        if (data['sucess']) {
          this.moduleList = data["data"];
          this.dataSource = new MatTableDataSource<any[]>(data["data"]);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        }
        else {
          this.toastr.warning(data['msg'], 'Advertencia');
        }


      }
    );
  }

  public Save() {
    console.log('===============================================');
    console.log(' INICIO SAVE ');
    console.log(this.cou_in_id);
    this.ContentCourses.controls['cou_in_id'].setValue(this.cou_in_id);

    if (this.ContentCourses.valid) {
      console.log(this.ContentCourses.getRawValue());
      if (this.editActivo == true) {

        this.dialogService.openConfirmDialog('¿Seguro de modificar este registro?')
          .afterClosed().subscribe(res => {
            if (res) {
              this.moduleServices.Update(this.ContentCourses.getRawValue()).subscribe(
                data => {
                  console.log(data);

                  if (data['sucess']) {
                    this.editActivo = false;
                    let result = data['data'][0];
                    this.ContentCourses.controls['mod_in_id'].setValue(result.ID);
                    this.ContentCourses.reset();
                    this.ContentCourses.controls['mod_in_type_module'].setValue('1');
                    this.ContentCourses.controls['mod_in_status'].setValue('1');
                    this.LoadModuleList();
                    this.toastr.success(data['msg'], 'Correcto');

                  }
                  else {
                    this.toastr.warning(data['msg'], 'Advertencia');
                  }
                }
              );

            }
          });

      }
      else {

        this.dialogService.openConfirmDialog('¿Seguro de guardar este registro?')
          .afterClosed().subscribe(res => {
            if (res) {

              this.moduleServices.Insert(this.ContentCourses.getRawValue()).subscribe(
                data => {

                  if (data['sucess']) {
                    this.editActivo = false;
                    let result = data['data'][0];
                    this.ContentCourses.controls['mod_in_id'].setValue(result.ID);
                    this.ContentCourses.reset();
                    this.ContentCourses.controls['mod_in_type_module'].setValue('1');
                    this.ContentCourses.controls['mod_in_status'].setValue('1');
                    this.LoadModuleList();
                    this.toastr.success(data['msg'], 'Correcto');
                  }
                  else {
                    this.toastr.warning(data['msg'], 'Advertencia');
                  }
                }
              );


            }
          });
      }
    }
    else {
      this.toastr.warning('Por favor complete los datos del formulario.', 'Advertencia');
    }
  }

  public Modify(element) {
    this.editActivo = true;
    this.ContentCourses.setValue(element);
  }

  public Detele(mod_in_id: number) {
    this.dialogService.openConfirmDialog('¿Seguro de eliminar este registro?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.moduleServices.Delete(mod_in_id).subscribe(
            data => {

              if (data['sucess']) {
                this.editActivo = false;
                this.ContentCourses.controls['mod_in_id'].setValue(mod_in_id);
                this.ContentCourses.reset();
                this.LoadModuleList();
                this.ContentCourses.controls['mod_in_type_module'].setValue('1');
                this.ContentCourses.controls['mod_in_status'].setValue('1');
                this.toastr.success(data['msg'], 'Correcto');

              }
              else {
                this.toastr.warning(data['msg'], 'Advertencia');
              }


            }
          );
        }
      });
  }

  public Next()
  {
    console.log("MODULE");
console.log(this.moduleList);
    this.SendDataModule.emit(this.moduleList);
    //this.moviecomponer.LoadModuleList();
  }

  
}
